@if (objectForm) {
  <div [formGroup]="objectForm">
    <h3>
      Summa
      <label
        *hasPermission="[GroupPermission.MENU_BOOKKEEPER]"
        class="ml-4"
        nz-checkbox
        id="isAutomaticCalculationsEnabled"
        [(ngModel)]="isAutomaticCalculationsEnabled"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onIsAutomaticCalculationsEnabledChanged($event)"
        >Automātiskie aprēķini</label
        >
      </h3>
      <nz-form-item>
        <nz-form-label nzRequired nzFor="sumWithoutVat">Summa bez PVN</nz-form-label>
        <nz-form-control clValidationError="sumWithoutVat">
          <nz-input-group nzAddOnAfter="EUR">
            <input type="number" nz-input id="sumWithoutVat" formControlName="sumWithoutVat" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzRequired nzFor="vatPercent">PVN %</nz-form-label>
        <nz-form-control clValidationError="vatPercent">
          <nz-select nzShowSearch nzPlaceHolder="PVN %" formControlName="vatPercent">
            @for (vatType of vatTypes$ | async; track vatType.id) {
              <nz-option
                [nzLabel]="vatType.name"
                [nzValue]="stringToNumber(vatType.description)"
              ></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzRequired nzFor="sumVat">PVN summa</nz-form-label>
        <nz-form-control clValidationError="sumVat">
          <nz-input-group nzAddOnAfter="EUR">
            <input type="number" nz-input id="sumVat" formControlName="sumVat" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label>ar PVN</nz-form-label>
        <nz-form-control>
          <nz-input-group nzAddOnAfter="EUR">
            <input
              type="number"
              nz-input
              id="sumWithVatBeforePenalty"
              [(ngModel)]="sumWithVatBeforePenalty"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="true"
              />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="penaltySumWithoutVat">Līgumsods</nz-form-label>
          <nz-form-control clValidationError="penaltySumWithoutVat">
            <nz-input-group nzAddOnAfter="EUR">
              <input type="number" nz-input id="penaltySumWithoutVat" formControlName="penaltySumWithoutVat" />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzRequired nzFor="sumWithVat">Kopā ar PVN un līgumsodu</nz-form-label>
          <nz-form-control clValidationError="sumWithVat">
            <nz-input-group nzAddOnAfter="EUR">
              <input type="number" nz-input id="sumWithVat" formControlName="sumWithVat" />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    }
